var _use, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsCodebuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.375 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.188,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.99 50.117l-5.041-.81L0 50.058 4.402 64.79l9.588-14.673z",
    fill: "#b7ca9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 33.298v13.376l4.526.615 8.825-6.868-8.825-7.727L0 33.298z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.526 51.024l9.464-.907v13.405l-9.464.644L.876 57.18l3.65-6.156z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.072 30.702l4.917-.78-9.464-14.849L0 29.941l9.072.761z",
    fill: "#3c4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.526 14.41l9.464 2.107v13.405l-9.464-.898V14.41zm0 18.312l9.464.595v13.415l-9.464.605V32.722z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.99 25.942l7.237-1.6-9.918-12.81-6.783 13.151 9.464 1.259z",
    fill: "#3c4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.309 11.22l9.918 2.634v10.488l-9.918-1.581V11.22z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.227 55.639l-7.217-1.6-9.484 1.268 6.784 13.522 9.918-13.19z",
    fill: "#b7ca9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.309 57.24l9.918-1.581v10.527l-9.918 2.644-8.969-6.585 8.969-5.005z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.928 29.932l-9.072.761-12.093-1.912 9.856-17.6 11.309 18.751z",
    fill: "#3c4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.526 55.308v-4.322L0 50.059v13.376l11.309 5.356V57.23l-6.784-1.922z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.949 50.068l-9.072-.761-12.114 1.922 9.856 17.239 11.33-18.4z",
    fill: "#b7ca9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.619 11.181l-9.856 2.624v14.976l9.856-1.122 10.722-6.127-10.722-10.351zm0 20.497l-9.856.761v14.976l9.856.742 10.722-7.883-10.722-8.595zm0 20.742l-9.856-1.132v14.976l9.856 2.634 9.917-10.702-9.917-5.776z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3c4929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.598 6.878l-9.907 14.927 10.082 1.746 10.217-2.254L24.598 6.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.248 26.957l-10.093 1.249-20.557-3.258L34.99.098l20.258 26.859z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.99 51.396L54.444 40.03 34.99 28.576l-10.392 1.405V50l10.392 1.395z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.99 28.576v22.819l20.258-2.732V31.308L34.99 28.576z",
    fill: "#759c3e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b7ca9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.248 53.054l-10.093-1.258-20.557 3.268L34.99 79.99l20.258-26.937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.928 58.673l-10.082-2.234-10.114 1.756 9.485 16.322 10.711-15.844z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.68 58.185V70.39L34.989 80l18.938-17.756-18.938-5.063-10.392-2.117v5.932l-9.917-2.81zm-3.371-35.424V11.22L0 16.566v13.376l4.526-.917v-4.342l6.784-1.922zm13.289-3.765v5.951L34.99 22.84l18.701-5.063L34.989.02 14.68 9.62v12.185l9.918-2.81z",
    fill: "#4b612c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.99 0v22.839l20.258 4.117V9.581L34.99 0zM70 29.952V16.566l-11.381-5.385V27.64L70 29.952zm0 16.721V33.308l-11.381-1.541v16.449L70 46.673zM34.99 57.181v22.81l20.258-9.59V53.054L34.99 57.181zM70 63.425V50.059l-11.381 2.312V68.81L70 63.425z",
    fill: "#759c3e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCodebuild);
export default __webpack_public_path__ + "static/media/aws-codebuild.6e1b6f37fc6d319c24785cbba9b5cc27.svg";
export { ForwardRef as ReactComponent };